module.exports = __webpack_public_path__ + "static/media/never_miss_a_message.3d06d60a.png";